import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendEnrollmentToCse(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.sendToCse.url, { id: enrollmentId }))
    .post()
}
